<template>
<div
  v-if="canClaimCreate"
  class="claim-add_cla"
  :class="{ [curTheme]: true }">
  <el-tooltip :content="title" placement="top">
    <button class="cla_btn" @click="winOn = true"/>
  </el-tooltip>

  <el-dialog
    class="cla_win"
    :title="title"
    :visible.sync="winOn">
    <div class="cla_label">Причина жалобы:</div>
    <el-input
      type="textarea"
      :autosize="{ minRows: 2, maxRows: 20 }"
      placeholder="Введите текст жалобы..."
      v-model="msg"/>
    <div slot="footer" class="dialog-footer buttons-wrap">
      <button
        class="dialog-primary-btn"
        @click="claimAdd">
        Подать жалобу
      </button>
      <button
        class="dialog-empty-btn"
        @click="winOn = false">
        Закрыть окно
      </button>
    </div>
  </el-dialog>

</div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';

export default {

  props: {
    entityType: String,
    entityId: String,
  },

  data() {
    return {
      msg: '',
      winOn: false,
      entityVars: {
        User: {
          to: 'пользователя',
        },
        Object: {
          to: 'объект',
        },
        Review: {
          to: 'отзыв',
        },
        Comment: {
          to: 'комментарий',
        },
      },
    };
  },

  computed: {
    title() {
      return `Подать жалобу на ${this.entityVars[this.entityType].to}`;
    },

    userData() {
      return this.$store.getters['user/getUserData'];
    },

    canClaimCreate() {
      const ud = this.userData;
      return ud && ud.Transient.Permissions.CLAIM_CREATE;
    },
  },

  methods: {
    claimAdd() {
      const params = {
        message: this.msg,
        entityType: this.entityType === 'Comment' ? 'Review' : this.entityType,
        entityId: this.entityId,
      };
      Vue.$loading.on();
      axios.post('claims', params).then(() => {
        this.$message.success('Жалоба отправлена.');
        this.msg = '';
        this.winOn = false;
        Vue.$loading.off();
      }).catch((err) => {
        this.$notify.error(err.response.data[0]);
        this.msg = '';
        this.winOn = false;
        Vue.$loading.off();
      });
    },
  },

};
</script>

<style lang="scss">
@import "../styles/common/main";

.claim-add_cla {
  .el-dialog {
    max-width: 800px;
  }
  .cla_label {
    margin-bottom: 10px;
    font-weight: 400;
  }
  .cla_btn {
    width: 28px;
    height: 28px;
    cursor: pointer;
    background: 0 0 no-repeat url(/static/grx/icons/claim.svg);
    &:hover {
      background-image: url(/static/grx/icons/claim-hover.svg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ClaimAdd.vue